import Company from '../company';
import { filter, sortCompanies } from '../filters/filter';
import Interface from '../Interface';

type ListCompanies = {
  companies : Array<Company>
  filterConditions: string | undefined
}

const listCompanies = (props : ListCompanies) : Interface => {
  if(!props.companies)
    return { companies: [] };

  const getCompanies = () : Array<JSX.Element> => {
    return props
      .companies
      .sort(sortCompanies)
      .filter(x => filter(props.filterConditions, x))
      .map((company, i) => <Company {...company} key={i} />);
  };

  return {
    companies: getCompanies()
  };
};

export default listCompanies;